let info = {
  name: "Bongomin Daniel",
  logo_name: "Daniel",
  flat_picture: require("./src/assets/profile1.jpeg"),
  config: {
    use_cookies: true,
    navbar: {
      blur: false
    }
  },
  description:
    "Full-stack Software Engineer experienced in client and server-side development. Providing clean code and a keen eye for detail in design. Specializing in JavaScript (Vue.js, React.js), Python Django, Nest.js, Node.js, and cross-platform mobile development using Quasar. Proficient in creating seamless user experiences with Vue.js, React.js, and Quasar, while ensuring clean and optimized server solutions with Python Django, Nest.js, and Node.js. Strong background in database management, RESTful APIs, and scalable server architectures. Constantly learning and adapting to the evolving IT industry. Let's collaborate to create cutting-edge solutions tailored to your needs.",
  links: {
    linkedin: "https://www.linkedin.com/in/daniel-bongomin/",
    github: "https://github.com/bongomin",
    resume: "https://drive.google.com/file/d/1nxkS2pu4THqhk6RPHByH-qAooKA-1Yjx/view?usp=sharing"
  },
  education: [
    {
      name: "Kyambogo University",
      place: "Kampa, Uganda",
      date: "August 2014 – May 2017",
      degree: "Bachelor of Information Systems",
      gpa: "3.1",
      description:
        "",
      skills: [
        "Software Engineering",
        "Web Development",
        "Database Management",
        "Computer Networking",
        "Computer Hardware",
        "Computer Software",
        "web programming",
        "UI/UX design",
        "Front-end developing",
      ]
    },
    {
      name: "Kajjansi Progressive Secondary School",
      place: "Kampala, Uganda",
      date: "February 2012 – November 2013",
      Certification: "Uganda Advanced Certificate of Education (UACE)",
      description:
        "",
      skills: [
        "A-Level",
      ]
    },
    {
      name: "Kajjansi Progressive Secondary School",
      place: "Kampala, Uganda",
      date: "February 2008 – November 2011",
      Certification: "Uganda Certificate of Education (UCE)",
      description:
        "",
      skills: [
        "O-Level",
      ]
    },
  ],
  experience: [
    {
      name: "BPOSeats",
      place: "Cebu , Philippines",
      date: "May 2021 - present",
      position: "Full Stack Software Engineer | Dev Lead",
      description:
        "As the Full Stack Software Engineer | Dev Lead, I am responsible for overseeing the collaboration and tasks performed by team members. I ensure timely delivery of projects by coordinating with lead managers and providing guidance to the development team. I provide technical expertise in Vue.js for the client-side and Python Django for the server-side",
      skills: ["JavaSript", "VueJS", "Python", "Django", "Postgres"]
    },
    {
      name: "Learning Dollars Talent",
      place: "Santa Clara, California, United States",
      date: "Feb 2020 - April 2023",
      position: "Freelance Web Developer",
      description:
        "Experienced Freelance Web Developer skilled in JavaScript, ReactJS, Vue.js, Python, Django, and AWS. Strong problem-solving abilities and a track record of delivering high-quality projects on time",
      skills: ["Javascript", "Typescript", "ReactJS", "React-Redux", "webpack", "NLP", 'Vue Js', 'Python', 'Django', 'NodeJS', 'AWS', 'expressJs']
    },
    {
      name: "Esteemed Inc",
      place: "5430 66th Ave Olympia, WA 98502",
      date: "Jan-2022 – July-2022",
      position: "Full Stack Software Engineer",
      description:
        "As a Full Stack Software Engineer, I developed clean and modular web-based SaaS applications using the Quasar framework. I debugged and refactored existing applications, responded to critical support issues, and collaborated with the Software Architect to ensure coding standards and architectural practices. I also assisted Senior Developers, creating highly interactive web applications using JavaScript, HTML, CSS, JSON, Quasar, Vue3, and integrating Nest Js Restful APIs for optimal performance on multiple platforms.",
      skills: ["JavaSript", "VueJS 3", "Nest Js ", "Quasar", "Node Js", "Postgres"]
    },
    {
      name: "Buq Limited (buq.com)",
      place: "Fox Odge, NG76LH United Kingdom",
      date: "Sep-2019 – Nov-2019",
      position: "Full stack software engineer (Contract)",
      description:
        "Improve Customer satisfaction and lifetime value by developing an ecommerce auto-pilot software using Vuejs2/3 for frontend and Node Js for backend implementations",
      skills: ["JavaSript", "VueJS 2/3", "Node Js", "Sql"]
    },
    {
      name: "ABC CAPITAL BANK LTD",
      place: "Kampala, Uganda",
      date: "Mar-2018 - June-2019",
      position: "IT Support Engineer, System Administrator",
      description: "A professional systems administrator with strong experience managing server infrastructures and data-center operations across Unix, Linux, Windows, and Mac OS X platforms. Effectively plan, install, configure and optimize IT infrastructures to achieve high availability and performance",
      skills: ["Windows Servers", "Oracle", "System Administration skills", "User Support"]
    },
    {
      name: "Refactory",
      place: "kampala, Uganda",
      date: "Mar-2017 - May-2017 ",
      position: "Software Engineer",
      description: "Developing Front and Back End web-based solutions for small business clients atleading Companies within Uganda",
      skills: ["ReactJs", "VueJS", "NodeJS", "ExpressJS", "MongoDB", "Python", "Django", "AWS", "Git", "Github", "Javascript", "Typescript", "React-Redux", "webpack", "NLP", 'Vue Js', 'Python', 'Django', 'NodeJS', 'AWS', 'expressJs']
    },
  ],
  skills: [
    {
      title: "UX/UI Design",
      info: ["Figma", "Illustrator", "XD", "Photoshop", "Gimp"],
      icon: "fa fa-pencil-square-o"
    },
    {
      title: "Language",
      info: [
        "Python", "Javascript", "TypeScript"],
      icon: "fa fa-code"
    },
    {
      title: "Front-end",
      info: [
        "HTML5", "CSS3", "Bootstrap3", "Es6"],
      icon: "fa fa-cubes"
    },
    {
      title: "web technologies",
      info: ["Vue", "React", "Node"],
      icon: "fas fa-laptop-code"
    },
    {
      title: "Testing",
      info: ["TDD", "Jest", "Jasmine"],
      icon: "fas fa-check-circle"
    },
    {
      title: "Security",
      info: ["Cross-Site Scripting (XSS)", "Secure coding practices"],
      icon: "fas fa-shield-alt"
    }
  ],
  portfolio_design: [
    {
      name: "Keep it Green",
      title: "UI/UX Design",
      pictures: [
        {
          img: require("./src/assets/designs/Keep it green/cover.png"),
          title: "MoodBoard"
        },
        {
          img: require("./src/assets/designs/Keep it green/show.png"),
          title: "show"
        },
      ],
      technologies: ["Figma", "Photoshop"],
      category: "Visual Design",
      github: "",
      date: "Jan, 2022",
      visit: "",
      description:
        ""
    },
    {
      name: "Digital agency website",
      title: "UI/UX Design",
      pictures: [
        {
          img: require("./src/assets/designs/digital agency/behance cover.png"),
          title: "MoodBoard"
        },
        {
          img: require("./src/assets/designs/digital agency/1. start.png"),
          title: "App Elements"
        },
        {
          img: require("./src/assets/designs/digital agency/2. about.png"),
          title: "App Elements"
        },
        {
          img: require("./src/assets/designs/digital agency/3. Our services.png"),
          title: "App Elements"
        },
        {
          img: require("./src/assets/designs/digital agency/4. latest project.png"),
          title: "App Elements"
        },
      ],
      technologies: ["Figma", "Illustrator"],
      category: "Visual Design",
      github: "",
      date: "Dec, 2021",
      visit: "",
      description:
        ""
    },
    {
      name: "Credit card design",
      title: "Illustration",
      pictures: [
        {
          img: require("./src/assets/designs/credit/behance cover.png"),
          title: "MoodBoard"
        },
        {
          img: require("./src/assets/designs/credit/degisning.png"),
          title: "Degisning"
        },
        {
          img: require("./src/assets/designs/credit/Dual tune.png"),
          title: "Dual tune"
        },
        {
          img: require("./src/assets/designs/credit/Glassmorphism.png"),
          title: "Glassmorphism"
        },
        {
          img: require("./src/assets/designs/credit/Gradiant.png"),
          title: "Gradiant"
        },
        {
          img: require("./src/assets/designs/credit/Monochrome.png"),
          title: "Monochrome"
        },
        {
          img: require("./src/assets/designs/credit/Neumorphism.png"),
          title: "Neumorphism"
        },
      ],
      technologies: ["Figma", "Illustrator"],
      category: "Visual Design",
      github: "",
      date: "Dec, 2021",
      visit: "",
      description:
        ""
    },
    {
      name: "BOOKSI",
      title: "E-Book library - UI/UX Design",
      pictures: [
        {
          img: require("./src/assets/designs/booksi/behance cover.png"),
          title: "Cover"
        },
        {
          img: require("./src/assets/designs/booksi/behance board.png"),
          title: "MoodBoard"
        },
        {
          img: require("./src/assets/designs/booksi/login.png"),
          title: "login"
        },
        {
          img: require("./src/assets/designs/booksi/register.png"),
          title: "register"
        },
        {
          img: require("./src/assets/designs/booksi/home page.png"),
          title: "homepage"
        },
        {
          img: require("./src/assets/designs/booksi/For you.png"),
          title: "just for you"
        }
      ],
      technologies: ["Figma", "Photoshop"],
      category: "Visual Design",
      github: "",
      date: "Nov, 2021",
      visit: "",
      description:
        " BOOKSI is Ebook android app for easy read books."
    },
    {
      name: "Quiet Weather",
      title: "UI/UX Design",
      pictures: [
        {
          img: require("./src/assets/designs/weather/Wooden Hand iPhone 12 Pro.png"),
          title: "MoodBoard"
        },
        {
          img: require("./src/assets/designs/weather/artboard.png"),
          title: "show"
        },
        {
          img: require("./src/assets/designs/weather/weather app react native.png"),
          title: "components"
        },
      ],
      technologies: ["Figma", "Illustration"],
      category: "Visual Design",
      github: "",
      date: "Nov, 2021",
      visit: "",
      description:
        "Quiet Weather is a react native app by openweathermap api, i designed the ui/ux and coding it in react native, enjoy it!"
    },
    {
      name: "Pill Reminder",
      title: "Pill Reminder - Mockup Design",
      pictures: [
        {
          img: require("./src/assets/designs/pill reminder/Web 1.png"),
          title: "Moodboard"
        },
        {
          img: require("./src/assets/designs/pill reminder/1.png"),
          title: "Mockups 1"
        },
        {
          img: require("./src/assets/designs/pill reminder/2.png"),
          title: "Mockups 2"
        }
      ],
      technologies: ["XD", "Illustrator"],
      category: "Visual Design",
      github: "",
      date: "Apr, 2021",
      visit: "",
      description:
        "pill reminder app for nessecary drugs for the day."
    },
  ],
  portfolio: [
    {
      name: "Social Media App",
      pictures: [
        {
          img: require("./src/assets/portfolio/social media/social2.png"),
        },
        {
          img: require("./src/assets/portfolio/social media/social1.png")
        },
        {
          img: require("./src/assets/portfolio/social media/social3.png")
        },
        {
          img: require("./src/assets/portfolio/social media/social4.png")
        },
        {
          img: require("./src/assets/portfolio/social media/social5.png")
        },
      ],
      technologies: ["reactJS", "scss", "Firebase"],
      category: "Web App",
      date: "Jan, 2020 - 30 days",
      github:
        "https://github.com/bongomin/dev-hub-2020",
      visit: "https://dannydevchat.vercel.app/",
      description:
        " Social Media called DannyDev App with features: Live Chat, upload images, tags, filter search with title/content/tag, and more."
    },
    {
      name: "Hqzen",
      pictures: [
        {
          img: require("./src/assets/portfolio/hqzen/hqzen1.png"),
        },
        {
          img: require("./src/assets/portfolio/hqzen/hqzen2.png")
        },
        {
          img: require("./src/assets/portfolio/hqzen/hqzen3.png")
        },
        {
          img: require("./src/assets/portfolio/hqzen/hqzen4.png")
        },
      ],
      technologies: ["Vue Js 2/3", "Sass/Css", "Python", "Django/Api Silio"],
      category: "Web App",
      date: "Aug, 2020 - Jun 2023",
      github:
        "",
      visit: "https://hqzen.com/",
      description:
        "hqzen is Productivity Engine: An entire ecosystem of tools for engaged custom solutions for the individual or scaling teams."
    },
    {
      name: "Scholarship App",
      pictures: [
        {
          img: require("./src/assets/portfolio/scholarship app/scholar1.png"),
        },
        {
          img: require("./src/assets/portfolio/scholarship app/scholar2.png"),
        },
        {
          img: require("./src/assets/portfolio/scholarship app/scholar3.png")
        },
        {
          img: require("./src/assets/portfolio/scholarship app/scholar4.png")
        },
        {
          img: require("./src/assets/portfolio/scholarship app/scholar5.png")
        },
        {
          img: require("./src/assets/portfolio/scholarship app/scholar6.png")
        },
        {
          img: require("./src/assets/portfolio/scholarship app/scholar7.png")
        }

      ],
      technologies: ["HTML", "CSS", "JavaSript", "JQuery", "NodeJS", 'ExpressJs', "MongoDB"],
      category: "Web App",
      date: "Apr, 2019 - May, 2019",
      github: "https://github.com/bongomin/scholar-track",
      visit: "https://scholar-tracker.herokuapp.com/student",
      description:
        "Scholarship App is an online Scholarship Tracking app for NGO's ,Primary,Secondary Schools and university students. It has features: login, register, Reports, Parents Info,'Students Info' and more."
    },
    {
      name: "Share Story Blog App",
      pictures: [
        {
          img: require("./src/assets/portfolio/shareStoryApp/story1.png")
        },
        {
          img: require("./src/assets/portfolio/shareStoryApp/story2.png")
        },
        {
          img: require("./src/assets/portfolio/shareStoryApp/story3.png")
        },
      ],
      technologies: ["HTML%", "css", "node ExpressJs", "MongoDB"],
      category: "Web App",
      date: "Aug, 2019 - 2 days",
      github:
        "https://github.com/bongomin/Share-Story-app",
      visit: "https://share-stories.herokuapp.com/stories",
      description:
        " Share Story Blog App is a web app for sharing stories and ideas. It has features: login, register, share stories, share ideas, and more."
    },
    {
      name: "Applybpo",
      pictures: [

        {
          img: require("./src/assets/portfolio/applybpo/applybpo.png"),
        },
        {
          img: require("./src/assets/portfolio/applybpo/applybpo2.png")
        },
      ],
      technologies: ["Vue Js 2/3", "Sass/Css", "Poython", "Django/Api Silio"],
      category: "Web App",
      date: "Aug, 2020 - Jun 2022",
      github:
        "",
      visit: "https://applybpo.com/",
      description:
        "Applybpo is an app that manages employees employment information like payrols, leaves ,displinary actions etc."
    },
    {
      name: "Portfolio",
      pictures: [
        {
          img: require("./src/assets/portfolio/Portfolio/portf1.png"),
        },
        {
          img: require("./src/assets/portfolio/Portfolio/portf2.png")
        },
      ],
      technologies: ["Vue Js 3", "CSS"],
      category: "Web Site",
      date: "Jan, 2020 - Always updating",
      github:
        "https://github.com/bongomin/my_profile",
      visit: "https://my-profile-murex-five.vercel.app/",
      description:
        "I developed my Portfolio using Vue Js 3  and used EmailJS as a service that allows sending emails directly from a client-side JavaScript code to implement the contact form."
    },
  ],
};

export default info;
